import React, { useState } from 'react';
import StoreCategoryWrapper from '../../../../views/store/category/StoreCategoryWrapper/StoreCategoryWrapper';
import { useCategoriesData } from '../../../../common/utils/utils';
import { getDefaultStaticProps, getLangPaths } from '../../../api/_props';
import Language from '../../../../common/decorators/Language';
import { getData } from '../../../../common/utils/router';
const project = require('../../../../scripts/configs/project');
import moment from 'moment';
import { usePropertiesFilters } from '../../../../views/store/initData';

const StoreCategory = ({ subCategories, category, translates, categoriesData, properties, categoriesMeta }) => {
    const { categories, loadMoreCategories } = useCategoriesData(categoriesData, categoriesMeta);

    const [productData, setInitDataProduct] = useState(null);
    const propertiesFilters = usePropertiesFilters(productData, properties);
    const [loadingPrice, setLoadingPrice] = useState(true);

    return (
        <Language translates={translates} page={'/store'}>
            <StoreCategoryWrapper
                loaded={Boolean(productData)}
                translates={translates}
                subCategories={subCategories}
                category={category}
                categories={categories}
                loadMoreCategories={loadMoreCategories}
                product={productData}
                propertiesFilters={propertiesFilters}
                isLoadingPrice={loadingPrice}
                setLoadingPrice={setLoadingPrice}
                setInitDataProduct={setInitDataProduct}
            />
        </Language>
    );
};

// TODO IP
export async function getStaticProps({ params }) {
    const defaultProps = await getDefaultStaticProps(params?.lang, `/store/category/${params?.data}`, ['/store', '/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    const { lang, currency } = defaultProps?.props;

    const category = await getData(
        `/api/v1/shop/product-categories/${params.data}?breadcrumbs=true`,
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm'),
        currency
    );
    if (!category.data) {
        return { notFound: true };
    }
    const subCategories = await getData(
        `/api/v1/shop/product-categories?filter[parent_id]=${category.data?.id}&page[size]=20&include=media`,
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm'),
        currency
    );
    if (!subCategories.data) {
        return { notFound: true };
    }
    const properties = await getData(
        `/api/v1/shop/product-properties?filter[category]=${category.data.id}&include=values`,
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm'),
        currency
    );

    const categories = await getData(
        '/api/v1/shop/product-categories?filter[parent_id]=0&page[size]=15&include=media',
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm'),
        currency
    );
    if (!categories.data) {
        return { notFound: true };
    }
    return {
        props: {
            ...defaultProps.props,
            properties: properties?.data || [],
            categoriesData: categories?.data || [],
            categoriesMeta: { ...(categories?.meta || {}), ...(categories?.links || {}) },
            subCategories: subCategories,
            category: category,
            currency: currency || null
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = [];
    const langs = await getLangPaths();

    const categories = await getData(
        '/api/v1/shop/product-categories?filter[parent_id]=0&page[size]=20',
        false,
        false,
        moment().format('1DD.ss.2MM.3mm')
    );
    const list = categories?.data.reduce((acc, cat) => [...acc, cat, ...(cat?.children || [])], []);

    langs.forEach((lang) => {
        list?.forEach((cat) => {
            paths.push({
                ...lang,
                params: { ...lang.params, data: `${cat.url || cat.id}` }
            });
            if (cat.children?.length) {
                cat.children.forEach((child) => {
                    paths.push({
                        ...lang,
                        params: {
                            ...lang.params,
                            data: `${child.url || child.id}`
                        }
                    });
                });
            }
        });
    });
    return {
        paths,
        fallback: true
    };
}

export default StoreCategory;
